import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Picture } from "../lib/photos";

/** RoomCard — reused on /rooms index and cross-linked from amenity pages. */
export function RoomCard({ room, photo, className = "" }) {
  return (
    <article
      className={`group bg-cream flex flex-col overflow-hidden border border-tan ${className}`}
      data-testid={`room-card-${room.slug}`}
    >
      <Link to={`/rooms/${room.slug}`} className="block aspect-[4/3] overflow-hidden bg-forest-800">
        {photo && (
          <Picture
            photo={photo}
            className="block w-full h-full"
            imgClassName="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)]"
            sizes="(min-width: 1024px) 30vw, (min-width: 640px) 45vw, 100vw"
          />
        )}
      </Link>
      <div className="p-6 md:p-7 flex flex-col grow">
        <div className="flex items-baseline justify-between gap-4 mb-3">
          <h3 className="font-display text-2xl text-forest-900 tracking-tight">
            <Link to={`/rooms/${room.slug}`} className="hover:text-brass">
              {room.name}
            </Link>
          </h3>
          <span className="text-xs uppercase tracking-[0.18em] text-brass whitespace-nowrap">
            {room.corridor === "interior" ? "Interior" : "Exterior"}
          </span>
        </div>
        <p className="text-ink/80 leading-relaxed text-[0.95rem] mb-5">{room.short}</p>
        <ul className="mt-auto grid grid-cols-2 gap-2 text-xs text-ink/70">
          {room.highlights?.slice(0, 4).map((h) => (
            <li key={h} className="flex items-center gap-1.5">
              <span className="w-1 h-1 rounded-full bg-brass" /> {h}
            </li>
          ))}
        </ul>
        <div className="mt-6 flex items-center justify-between text-sm">
          <span className="text-ink/70">Sleeps {room.sleeps} · {room.beds}</span>
          <Link
            to={`/rooms/${room.slug}`}
            className="text-forest-900 hover:text-brass inline-flex items-center gap-1"
            data-testid={`room-details-${room.slug}`}
          >
            View room <ChevronRight size={14} />
          </Link>
        </div>
      </div>
    </article>
  );
}
